module.exports = __webpack_public_path__ + "fonts/trust_sans_medium_it-webfont.db58974c.woff";